import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      Added: 'Added',
      Available: 'Available',
      'Manage your integrations': 'Manage your integrations',
      'No integrations found': 'No integrations found',
      'No integrations have been added yet':
        'It looks like the application owner did not yet make any integrations available',
      'No connections': 'No connections',
      'Search integrations': 'Search integrations',
      'Needs configuration': 'Needs configuration',
      'Invalid configuration': 'Invalid configuration',
      'Not connected': 'Not connected',
      Disabled: 'Disabled',
      Unauthorized: 'Unauthorized',
      'Input required': 'Input required',
      Connected: 'Connected',
      Loading: 'Loading',
      'Select..': 'Select..',
      Example: 'Example',
      'Select field': 'Select field',
      'Select custom field': 'Select custom field',
      'Enter a field mapping.': 'Enter a field mapping.',
      'Search properties': 'Search properties',
      'Search fields': 'Search fields',
      'No fields found for mapping.': 'No fields found for mapping.',
      'No custom fields found for mapping.':
        'No custom fields found for mapping.',
      'Search connectors': 'Search connectors',
      Type: 'Type',
      'None selected': 'None selected',
      'Map a property to': 'Map a property to',
      'Mapping removed.': 'Mapping removed.',
      'Select a source property from your':
        'Select a source property from your',
      'data to the': 'data to the',
      field: 'field',
      'Map properties from your': 'Map properties from your',
      'data to one of the fields below': 'data to one of the fields below',
      'Signed in': 'Signed in',
      Save: 'Save',
      'Trying to connect...': 'Trying to connect...',
      'Connection failed': 'Connection failed',
      'Could not connect to {{connectionName}}. Please check your credentials':
        'Could not connect to {{connectionName}}. Please check your credentials.',
      'Need help? View our': 'Need help? View our',
      'Connection Guide': 'Connection Guide',
      'Successfully connected to {{connectionName}}':
        'Successfully connected to {{connectionName}}',
      'Please provide default values for the fields below. These will be applied when creating new {{selectedResource}} through our integration.':
        'Please provide default values for the fields below. These will be applied when creating new {{selectedResource}} through our integration.',
      'Configure the {{name}} integration in the':
        'Configure the {{name}} integration in the',
      'before linking your account. This integration will not be visible to your users until configured.':
        'before linking your account. This integration will not be visible to your users until configured.',
      'Something went wrong': 'Something went wrong',
      'The integration could not be authorized. Please make sure your settings are correct and try again.':
        'The integration could not be authorized. Please make sure your settings are correct and try again.',
      Authorize: 'Authorize',
      'Missing required fields': 'Missing required fields',
      'Missing required field mappings.': 'Missing required field mappings.',
      'Field Mapping': 'Field Mapping',
      'Admin configuration required': 'Admin configuration required',
      enabled: 'enabled',
      disabled: 'disabled',
      'settings are updated': 'settings are updated',
      'Updating failed': 'Updating failed',
      '{{connectionName}} is deleted': '{{connectionName}} is deleted',
      'Configurable Resources': 'Configurable Resources',
      'Re-authorize': 'Re-authorize',
      Disable: 'Disable',
      Enable: 'Enable',
      Disconnect: 'Disconnect',
      Delete: 'Delete',
      Close: 'Close',
      Connection: 'Connection',
      'Are you sure?': 'Are you sure?',
      Settings: 'Settings',
      Actions: 'Actions',
      'Configurable resources': 'Configurable resources',
      'Requires authorization': 'Requires authorization',
      'Authorization denied': 'Authorization denied',
      'Connection disabled': 'Connection disabled',
      'Re-authorization required': 'Re-authorization required',
      'Deny access?': 'Deny access?',
      'If you deny access, you will not be able to use this integration. Are you sure?':
        'If you deny access, you will not be able to use this integration. Are you sure?',
      'Yes, deny access': 'Yes, deny access',
      'Requested Data Access': 'Requested Data Access',
      'The application is requesting permission to access the following data.':
        'The application is requesting permission to access the following data.',
      'New permissions requested': 'New permissions requested',
      'The developer has updated the integration and requires additional permissions to keep it working.':
        'The developer has updated the integration and requires additional permissions to keep it working.',
      'Full Data Access': 'Full Data Access',
      'This application is requesting access to all data available through this connection.':
        'This application is requesting access to all data available through this connection.',
      'By authorizing you agree to grant the application access to the data listed above.':
        'By authorizing you agree to grant the application access to the data listed above.',
      '{{count}} fields': '{{count}} fields',
      'Updated Permissions Requested': 'Updated Permissions Requested',
      'Integration updated with new permissions':
        'This integration has been updated and requires access to additional data.',
      'Permission required': 'Permission required',
      'Permission denied': 'Permission denied',
      'Permission revoked': 'Permission revoked',
      'New permissions required': 'New permissions required',
    },
  },
  nl: {
    translation: {
      Added: 'Toegevoegd',
      Available: 'Beschikbaar',
      'Manage your integrations': 'Beheer je integraties',
      'No integrations found': 'Geen integraties gevonden',
      'No integrations have been added yet':
        'Er zijn nog geen integraties beschikbaar gesteld door de applicatie eigenaar',
      'No connections': 'Geen connecties',
      'Search integrations': 'Zoek integraties',
      'Needs configuration': 'Configuratie nodig',
      'Invalid configuration': 'Ongeldige configuratie',
      'Not connected': 'Niet verbonden',
      Disabled: 'Uitgeschakeld',
      Unauthorized: 'Ongeautoriseerd',
      'Input required': 'Input vereist',
      Connected: 'Verbonden',
      Loading: 'Laden',
      'Select..': 'Selecteer..',
      Example: 'Voorbeeld',
      'Select field': 'Selecteer field',
      'Select custom field': 'Selecteer custom field',
      'Enter a field mapping.': 'Voer een mapping in.',
      'Search properties': 'Zoek properties',
      'Search fields': 'Zoek fields',
      'No fields found for mapping.': 'Geen fields gevonden voor mapping.',
      'No custom fields found for mapping.':
        'Geen custom fields gevonden voor mapping.',
      'Search connectors': 'Zoek connectors',
      Type: 'Type',
      'None selected': 'Geen geselecteerd',
      'Map a property to': 'Map een property naar',
      'Mapping removed.': 'Mapping verwijderd.',
      'Select a source property from your':
        'Selecteer een bron property van je',
      'data to the': 'data naar de',
      field: 'field',
      'Map properties from your': 'Map properties van je',
      'data to one of the fields below':
        'data naar een van de onderstaande fields',
      'Signed in': 'Ingelogd',
      Save: 'Opslaan',
      'Trying to connect...': 'Verbinding maken...',
      'Connection failed': 'Verbinding mislukt',
      'Could not connect to {{connectionName}}. Please check your credentials':
        'Kon geen verbinding maken met {{connectionName}}. Controleer je credentials.',
      'Need help? View our': 'Hulp nodig? Bekijk onze',
      'Connection Guide': 'Connection Guide',
      'Successfully connected to {{connectionName}}':
        'Verbonden met {{connectionName}}',
      'Please provide default values for the fields below. These will be applied when creating new {{selectedResource}} through our integration.':
        'Vul hieronder standaardwaarden in voor de velden. Deze worden toegepast wanneer je nieuwe "{{selectedResource}}" maakt via onze integratie.',
      'Configure the {{name}} integration in the':
        'Configureer de {{name}} integratie in het',
      'before linking your account. This integration will not be visible to your users until configured.':
        'voordat je je account koppelt. Deze integratie is niet zichtbaar voor je gebruikers totdat deze is geconfigureerd.',
      'Something went wrong': 'Er is iets misgegaan',
      'The integration could not be authorized. Please make sure your settings are correct and try again.':
        'De integratie kon niet worden geautoriseerd. Controleer of je instellingen correct zijn en probeer het opnieuw.',
      Authorize: 'Autoriseren',
      'Missing required fields': 'Ontbrekende verplichte velden',
      'Missing required field mappings.':
        'Ontbrekende verplichte veldmappings.',
      'Field Mapping': 'Veldmapping',
      'Admin configuration required': 'Admin configuratie vereist',
      enabled: 'ingeschakeld',
      disabled: 'uitgeschakeld',
      'settings are updated': 'instellingen zijn bijgewerkt',
      'Updating failed': 'Bijwerken mislukt',
      '{{connectionName}} is deleted': '{{connectionName}} is verwijderd',
      'Configurable Resources': 'Configruabelen Resources',
      'Re-authorize': 'Herverbinden',
      Disable: 'Uitschakelen',
      Enable: 'Inschakelen',
      Disconnect: 'Ontkoppelen',
      Delete: 'Verwijderen',
      Close: 'Sluiten',
      Connection: 'Connectie',
      'When you delete a connection you will lose all your configured settings.':
        'Wanneer je een connectie verwijdert, verlies je al je geconfigureerde instellingen.',
      Settings: 'Instellingen',
      Actions: 'Acties',
      'Configurable resources': 'Configruabelen resources',
      'Requires authorization': 'Autorisatie vereist',
      'Authorization denied': 'Autorisatie geweigerd',
      'Connection disabled': 'Verbinding uitgeschakeld',
      'Re-authorization required': 'Herautorisatie vereist',
      'Deny access?': 'Toegang weigeren?',
      'If you deny access, you will not be able to use this integration. Are you sure?':
        'Als je de toegang weigert, kun je deze integratie niet gebruiken. Weet je het zeker?',
      'Yes, deny access': 'Ja, toegang weigeren',
      'Requested Data Access': 'Gevraagde gegevenstoegang',
      'The application is requesting permission to access the following data.':
        'De applicatie waarmee je verbinding maakt, vraagt toestemming om toegang te krijgen tot de volgende gegevens.',
      'New permissions requested': 'Nieuwe machtigingen aangevraagd',
      'The developer has updated the integration and requires additional permissions to keep it working.':
        'De ontwikkelaar heeft de integratie bijgewerkt en vereist extra machtigingen om deze werkend te houden.',
      'Full Data Access': 'Volledige gegevenstoegang',
      'This application is requesting access to all data available through this connection.':
        'Deze applicatie vraagt toegang tot alle gegevens die beschikbaar zijn via deze verbinding.',
      'By authorizing you agree to grant the application access to the data listed above.':
        'Door je te autoriseren, ga je ermee akkoord de applicatie toegang te verlenen tot de hierboven vermelde gegevens.',
      '{{count}} fields': '{{count}} velden',
      'Updated Permissions Requested': 'Bijgewerkte Toestemmingen Gevraagd',
      'Integration updated with new permissions':
        'Deze integratie is bijgewerkt en vereist toegang tot extra gegevens. De nieuwe velden zijn gemarkeerd als "Nieuw" voor uw beoordeling.',
      'Permission required': 'Toestemming vereist',
      'Permission denied': 'Toestemming geweigerd',
      'Permission revoked': 'Toestemming ingetrokken',
      'New permissions required': 'Nieuwe toestemmingen vereist',
    },
  },
  fr: {
    translation: {
      Added: 'Ajouté',
      Available: 'Disponible',
      'Manage your integrations': 'Gérer vos intégrations',
      'No integrations found': 'Aucune intégration trouvée',
      'No integrations have been added yet':
        "Il semble que le propriétaire de l'application n'ait pas encore rendu d'intégrations disponibles",
      'No connections': 'Aucune connexion',
      'Search integrations': 'Rechercher des intégrations',
      'Needs configuration': 'Nécessite une configuration',
      'Invalid configuration': 'Configuration invalide',
      'Not connected': 'Non connecté',
      Disabled: 'Désactivé',
      Unauthorized: 'Non autorisé',
      'Input required': 'Saisie requise',
      Connected: 'Connecté',
      Loading: 'Chargement',
      'Select..': 'Sélectionner..',
      Example: 'Exemple',
      'Select field': 'Sélectionner le champ',
      'Select custom field': 'Sélectionner un champ personnalisé',
      'Enter a field mapping.': 'Entrez un mappage de champ.',
      'Search properties': 'Rechercher des propriétés',
      'Search fields': 'Rechercher des champs',
      'No fields found for mapping.': 'Aucun champ trouvé pour le mappage.',
      'No custom fields found for mapping.':
        'Aucun champ personnalisé trouvé pour le mappage.',
      'Search connectors': 'Rechercher des connecteurs',
      Type: 'Type',
      'None selected': 'Aucun sélectionné',
      'Map a property to': 'Mapper une propriété à',
      'Mapping removed.': 'Mappage supprimé.',
      'Select a source property from your':
        'Sélectionnez une propriété source de votre',
      'data to the': 'données au',
      field: 'champ',
      'Map properties from your': 'Mapper des propriétés de votre',
      'data to one of the fields below':
        "données vers l'un des champs ci-dessous",
      'Signed in': 'Connecté',
      Save: 'Sauvegarder',
      'Trying to connect...': 'Tentative de connexion...',
      'Connection failed': 'Connexion échouée',
      'Could not connect to {{connectionName}}. Please check your credentials':
        'Impossible de se connecter à {{connectionName}}. Veuillez vérifier vos identifiants.',
      'Need help? View our': "Besoin d'aide ? Voir notre",
      'Connection Guide': 'Guide de Connexion',
      'Successfully connected to {{connectionName}}':
        'Connecté avec succès à {{connectionName}}',
      'Please provide default values for the fields below. These will be applied when creating new {{selectedResource}} through our integration.':
        'Veuillez fournir des valeurs par défaut pour les champs ci-dessous. Elles seront appliquées lors de la création de nouveaux {{selectedResource}} via notre intégration.',
      'Configure the {{name}} integration in the':
        "Configurez l'intégration {{name}} dans le",
      'before linking your account. This integration will not be visible to your users until configured.':
        "avant de lier votre compte. Cette intégration ne sera pas visible par vos utilisateurs tant qu'elle ne sera pas configurée.",
      'Something went wrong': 'Quelque chose a mal tourné',
      'The integration could not be authorized. Please make sure your settings are correct and try again.':
        "L'intégration n'a pas pu être autorisée. Veuillez vérifier que vos paramètres sont corrects et réessayez.",
      Authorize: 'Autoriser',
      'Missing required fields': 'Champs obligatoires manquants',
      'Missing required field mappings.':
        'Mappages de champs obligatoires manquants.',
      'Field Mapping': 'Mappage de champs',
      'Admin configuration required': "Configuration d'admin requise",
      enabled: 'activé',
      disabled: 'désactivé',
      'settings are updated': 'les paramètres sont mis à jour',
      'Updating failed': 'La mise à jour a échoué',
      '{{connectionName}} is deleted': '{{connectionName}} est supprimé',
      'Configurable Resources': 'Ressources configurables',
      'Re-authorize': 'Réautoriser',
      Disable: 'Désactiver',
      Enable: 'Activer',
      Disconnect: 'Déconnecter',
      Delete: 'Supprimer',
      Close: 'Fermer',
      Connection: 'Connexion',
      'Are you sure?': 'Êtes-vous sûr ?',
      Settings: 'Paramètres',
      Actions: 'Actions',
      'Configurable resources': 'Ressources configurables',
      'Requires authorization': 'Autorisation requise',
      'Authorization denied': 'Autorisation refusée',
      'Connection disabled': 'Connexion désactivée',
      'Re-authorization required': 'Réautorisation requise',
      'Deny access?': "Refuser l'accès ?",
      'If you deny access, you will not be able to use this integration. Are you sure?':
        "Si vous refusez l'accès, vous ne pourrez pas utiliser cette intégration. Êtes-vous sûr ?",
      'Yes, deny access': "Oui, refuser l'accès",
      'Requested Data Access': 'Accès aux données demandé',
      'The application is requesting permission to access the following data.':
        "L'application à laquelle vous vous connectez demande l'autorisation d'accéder aux données suivantes.",
      'New permissions requested': 'Nouvelles autorisations demandées',
      'The developer has updated the integration and requires additional permissions to keep it working.':
        "Le développeur a mis à jour l'intégration et nécessite des autorisations supplémentaires pour la maintenir fonctionnelle.",
      'Full Data Access': 'Accès complet aux données',
      'This application is requesting access to all data available through this connection.':
        'Cette application demande l_accès à toutes les données disponibles via cette connexion.',
      'By authorizing you agree to grant the application access to the data listed above.':
        'En autorisant, vous acceptez de donner à l_application l_accès aux données listées ci-dessus.',
      '{{count}} fields': '{{count}} champs',
      'Updated Permissions Requested': 'Autorisations Mises à Jour Requises',
      'Integration updated with new permissions':
        "Cette intégration a été mise à jour et nécessite l'accès à des données supplémentaires. Les nouveaux champs sont marqués comme « Nouveau » pour votre examen.",
      'Permission required': 'Autorisation requise',
      'Permission denied': 'Autorisation refusée',
      'Permission revoked': 'Autorisation révoquée',
      'New permissions required': 'Nouvelles autorisations requises',
    },
  },
  de: {
    translation: {
      Added: 'Hinzugefügt',
      Available: 'Verfügbar',
      'Manage your integrations': 'Ihre Integrationen verwalten',
      'No integrations found': 'Keine Integrationen gefunden',
      'No integrations have been added yet':
        'Es wurden noch keine Integrationen hinzugefügt',
      'No connections': 'Keine Verbindungen',
      'Search integrations': 'Integrationen suchen',
      'Needs configuration': 'Benötigt Konfiguration',
      'Invalid configuration': 'Ungültige Konfiguration',
      'Not connected': 'Nicht verbunden',
      Disabled: 'Deaktiviert',
      Unauthorized: 'Unautorisiert',
      'Input required': 'Eingabe erforderlich',
      Connected: 'Verbunden',
      Loading: 'Laden',
      'Select..': 'Auswählen..',
      Example: 'Beispiel',
      'Select field': 'Feld auswählen',
      'Select custom field': 'Benutzerdefiniertes Feld auswählen',
      'Enter a field mapping.': 'Geben Sie eine Feldzuordnung ein.',
      'Search properties': 'Eigenschaften suchen',
      'Search fields': 'Felder suchen',
      'No fields found for mapping.':
        'Keine Felder für die Zuordnung gefunden.',
      'No custom fields found for mapping.':
        'Keine benutzerdefinierten Felder für die Zuordnung gefunden.',
      'Search connectors': 'Konnektoren suchen',
      Type: 'Typ',
      'None selected': 'Keine ausgewählt',
      'Map a property to': 'Eigenschaft zuordnen zu',
      'Mapping removed.': 'Zuordnung entfernt.',
      'Select a source property from your':
        'Wählen Sie eine Quelleigenschaft aus Ihrem',
      'data to the': 'Daten zum',
      field: 'Feld',
      'Map properties from your': 'Eigenschaften zuordnen von Ihrem',
      'data to one of the fields below': 'Daten zu einem der folgenden Felder',
      'Signed in': 'Angemeldet',
      Save: 'Speichern',
      'Trying to connect...': 'Versuche zu verbinden...',
      'Connection failed': 'Verbindung fehlgeschlagen',
      'Could not connect to {{connectionName}}. Please check your credentials':
        'Verbindung zu {{connectionName}} konnte nicht hergestellt werden. Bitte überprüfen Sie Ihre Anmeldeinformationen',
      'Need help? View our': 'Brauchen Sie Hilfe? Sehen Sie sich unser',
      'Connection Guide': 'Verbindungsleitfaden',
      'Successfully connected to {{connectionName}}':
        'Erfolgreich verbunden mit {{connectionName}}',
      'Please provide default values for the fields below. These will be applied when creating new {{selectedResource}} through our integration.':
        'Bitte geben Sie Standardwerte für die untenstehenden Felder an. Diese werden angewendet, wenn neue {{selectedResource}} über unsere Integration erstellt werden.',
      'Configure the {{name}} integration in the':
        'Konfigurieren Sie die {{name}}-Integration in der',
      'before linking your account. This integration will not be visible to your users until configured.':
        'bevor Sie Ihr Konto verknüpfen. Diese Integration ist für Ihre Benutzer nicht sichtbar, bis sie konfiguriert ist.',
      'Something went wrong': 'Etwas ist schiefgelaufen',
      'The integration could not be authorized. Please make sure your settings are correct and try again.':
        'Die Integration konnte nicht autorisiert werden. Bitte stellen Sie sicher, dass Ihre Einstellungen korrekt sind und versuchen Sie es erneut.',
      Authorize: 'Autorisieren',
      'Missing required fields': 'Fehlende erforderliche Felder',
      'Missing required field mappings.':
        'Fehlende erforderliche Feldzuordnungen.',
      'Field Mapping': 'Feldzuordnung',
      'Admin configuration required': 'Admin-Konfiguration erforderlich',
      enabled: 'aktiviert',
      disabled: 'deaktiviert',
      'settings are updated': 'Einstellungen werden aktualisiert',
      'Updating failed': 'Aktualisierung fehlgeschlagen',
      '{{connectionName}} is deleted': '{{connectionName}} wurde gelöscht',
      'Configurable Resources': 'Konfigurierbare Ressourcen',
      'Re-authorize': 'Erneut autorisieren',
      Disable: 'Deaktivieren',
      Enable: 'Aktivieren',
      Disconnect: 'Trennen',
      Delete: 'Löschen',
      Close: 'Schließen',
      Connection: 'Verbindung',
      'Are you sure?': 'Sind Sie sicher?',
      Settings: 'Einstellungen',
      Actions: 'Aktionen',
      'Configurable resources': 'Konfigurierbare Ressourcen',
      'Requires authorization': 'Autorisierung erforderlich',
      'Authorization denied': 'Autorisierung verweigert',
      'Connection disabled': 'Verbindung deaktiviert',
      'Re-authorization required': 'Erneute Autorisierung erforderlich',
      'Deny access?': 'Zugriff verweigern?',
      'If you deny access, you will not be able to use this integration. Are you sure?':
        'Wenn Sie den Zugriff verweigern, können Sie diese Integration nicht verwenden. Sind Sie sicher?',
      'Yes, deny access': 'Ja, Zugriff verweigern',
      'Requested Data Access': 'Angeforderter Datenzugriff',
      'The application is requesting permission to access the following data.':
        'Die Anwendung, mit der Sie eine Verbindung herstellen, fordert die Berechtigung zum Zugriff auf die folgenden Daten an.',
      'New permissions requested': 'Neue Berechtigungen angefordert',
      'The developer has updated the integration and requires additional permissions to keep it working.':
        'Der Entwickler hat die Integration aktualisiert und benötigt zusätzliche Berechtigungen, damit sie weiterhin funktioniert.',
      'Full Data Access': 'Vollständiger Datenzugriff',
      'This application is requesting access to all data available through this connection.':
        'Diese Anwendung fordert Zugriff auf alle über diese Verbindung verfügbaren Daten.',
      'By authorizing you agree to grant the application access to the data listed above.':
        'Wenn Sie sich autorisieren, erteilen Sie der Anwendung die Erlaubnis, auf die oben aufgeführten Daten zuzugreifen.',
      '{{count}} fields': '{{count}} Felder',
      'Updated Permissions Requested':
        'Aktualisierte Berechtigungen Angefordert',
      'Integration updated with new permissions':
        'Diese Integration wurde aktualisiert und erfordert Zugriff auf zusätzliche Daten. Die neuen Felder sind zur Überprüfung als „Neu“ gekennzeichnet.',
      'Permission required': 'Berechtigung erforderlich',
      'Permission denied': 'Berechtigung verweigert',
      'Permission revoked': 'Berechtigung widerrufen',
      'New permissions required': 'Neue Berechtigungen erforderlich',
    },
  },
  es: {
    translation: {
      Added: 'Agregado',
      Available: 'Disponible',
      'Manage your integrations': 'Gestiona tus integraciones',
      'No integrations found': 'No se encontraron integraciones',
      'No integrations have been added yet':
        'Aún no se han agregado integraciones',
      'No connections': 'Sin conexiones',
      'Search integrations': 'Buscar integraciones',
      'Needs configuration': 'Necesita configuración',
      'Invalid configuration': 'Configuración inválida',
      'Not connected': 'No conectado',
      Disabled: 'Deshabilitado',
      Unauthorized: 'No autorizado',
      'Input required': 'Se requiere entrada',
      Connected: 'Conectado',
      Loading: 'Cargando',
      'Select..': 'Seleccionar..',
      Example: 'Ejemplo',
      'Select field': 'Seleccionar campo',
      'Select custom field': 'Seleccionar campo personalizado',
      'Enter a field mapping.': 'Introduce un mapeo de campo.',
      'Search properties': 'Buscar propiedades',
      'Search fields': 'Buscar campos',
      'No fields found for mapping.': 'No se encontraron campos para mapeo.',
      'No custom fields found for mapping.':
        'No se encontraron campos personalizados para mapeo.',
      'Search connectors': 'Buscar conectores',
      Type: 'Tipo',
      'None selected': 'Ninguno seleccionado',
      'Map a property to': 'Mapear una propiedad a',
      'Mapping removed.': 'Mapeo eliminado.',
      'Select a source property from your':
        'Selecciona una propiedad fuente de tu',
      'data to the': 'datos al',
      field: 'campo',
      'Map properties from your': 'Mapear propiedades de tu',
      'data to one of the fields below':
        'datos a uno de los campos a continuación',
      'Signed in': 'Registrado',
      Save: 'Guardar',
      'Trying to connect...': 'Intentando conectar...',
      'Connection failed': 'Conexión fallida',
      'Could not connect to {{connectionName}}. Please check your credentials':
        'No se pudo conectar a {{connectionName}}. Por favor, verifica tus credenciales',
      'Need help? View our': '¿Necesitas ayuda? Ver nuestro',
      'Connection Guide': 'Guía de Conexión',
      'Successfully connected to {{connectionName}}':
        'Conectado exitosamente a {{connectionName}}',
      'Please provide default values for the fields below. These will be applied when creating new {{selectedResource}} through our integration.':
        'Por favor, proporciona valores predeterminados para los campos a continuación. Estos se aplicarán al crear nuevos {{selectedResource}} a través de nuestra integración.',
      'Configure the {{name}} integration in the':
        'Configura la integración {{name}} en el',
      'before linking your account. This integration will not be visible to your users until configured.':
        'antes de vincular tu cuenta. Esta integración no será visible para tus usuarios hasta que esté configurada.',
      'Something went wrong': 'Algo salió mal',
      'The integration could not be authorized. Please make sure your settings are correct and try again.':
        'La integración no pudo ser autorizada. Por favor, asegúrate de que tus ajustes son correctos y vuelve a intentarlo.',
      Authorize: 'Autorizar',
      'Missing required fields': 'Faltan campos requeridos',
      'Missing required field mappings.': 'Faltan mapeos de campos requeridos.',
      'Field Mapping': 'Mapeo de Campo',
      'Admin configuration required':
        'Se requiere configuración de administrador',
      enabled: 'habilitado',
      disabled: 'deshabilitado',
      'settings are updated': 'los ajustes están actualizados',
      'Updating failed': 'Actualización fallida',
      '{{connectionName}} is deleted': '{{connectionName}} ha sido eliminado',
      'Configurable Resources': 'Recursos Configurables',
      'Re-authorize': 'Reautorizar',
      Disable: 'Deshabilitar',
      Enable: 'Habilitar',
      Disconnect: 'Desconectar',
      Delete: 'Eliminar',
      Close: 'Cerrar',
      Connection: 'Conexión',
      'Are you sure?': '¿Estás seguro?',
      Settings: 'Ajustes',
      Actions: 'Acciones',
      'Configurable resources': 'Recursos Configurables',
      'Requires authorization': 'Requiere autorización',
      'Authorization denied': 'Autorización denegada',
      'Connection disabled': 'Conexión deshabilitada',
      'Re-authorization required': 'Se requiere reautorización',
      'Deny access?': '¿Denegar acceso?',
      'If you deny access, you will not be able to use this integration. Are you sure?':
        'Si deniegas el acceso, no podrás utilizar esta integración. ¿Estás seguro?',
      'Yes, deny access': 'Sí, denegar acceso',
      'Requested Data Access': 'Acceso a datos solicitado',
      'The application is requesting permission to access the following data.':
        'La aplicación a la que te estás conectando solicita permiso para acceder a los siguientes datos.',
      'New permissions requested': 'Nuevos permisos solicitados',
      'The developer has updated the integration and requires additional permissions to keep it working.':
        'El desarrollador ha actualizado la integración y requiere permisos adicionales para que siga funcionando.',
      'Full Data Access': 'Acceso completo a los datos',
      'This application is requesting access to all data available through this connection.':
        'Esta aplicación solicita acceso a todos los datos disponibles a través de esta conexión.',
      'By authorizing you agree to grant the application access to the data listed above.':
        'Al autorizar, aceptas conceder a la aplicación acceso a los datos mencionados anteriormente.',
      '{{count}} fields': '{{count}} campos',
      'Updated Permissions Requested': 'Permisos Actualizados Solicitados',
      'Integration updated with new permissions':
        'Esta integración se ha actualizado y requiere acceso a datos adicionales. Los nuevos campos están marcados como "Nuevo" para su revisión.',
      'Permission required': 'Permiso requerido',
      'Permission denied': 'Permiso denegado',
      'Permission revoked': 'Permiso revocado',
      'New permissions required': 'Nuevos permisos requeridos',
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
